import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { SubmissionConfig } from '../components';
import { PropertyHelper, EModalType, ModalHelper, OutputsHelper, IOutputValue, ActionHelper } from '../helpers';
import { IDropdownOption } from 'office-ui-fabric-react';

class SubmissionConfigContainer extends React.Component<any, any> {

	updateProperty = (key: string, value: any) => {

		let { submission } = this.props.state;

		submission = PropertyHelper.updateProperty(submission, key, value);

		store.dispatch({
			type: types.UPDATE_SUBMISSION_DIALOG,
			submission: submission
		});

	}

	closeDialog = (save?: boolean) => {

		let { state } = this.props;

		if (save) {

			let errorMessages: string[] = this.getErrorMessages();

			if (errorMessages.length) {

				store.dispatch({
					type: types.SET_MODAL_ERROR_MESSAGES,
					errorMessages: errorMessages
				});

				//scroll to the top of the dialog so that the error message is visible
				ModalHelper.scrollToErrorDisplay();

			}
			else {

				//save the submission component
				store.dispatch({
					type: types.UPDATE_SUBMISSION,
					componentId: state.componentId,
					submission: state.submission
				});

				let outputsInUse: {} = OutputsHelper.getLatestOutputsInUse();
				store.dispatch({
					type: types.UPDATE_OUTPUTS_IN_USE,
					outputsInUse: outputsInUse
				});

				//close the modal
				store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

			}

		}
		else {
			//close the modal anyway
			store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
		}

	}

	getErrorMessages = (): string[] => {
		return PropertyHelper.getErrorMessages(this.props.state.submission.Properties, false);
	}

	updateActionOutput = (index: number, name: string) => {
		store.dispatch({ type: types.UPDATE_ACTION_OUTPUT, index: index, name: name });
	}

	public render() {

		let { submission } = this.props.state;

		let outputOptions: IDropdownOption[] = OutputsHelper.getOutputDropdownOptions(this.props.outputs, null);

		return (
			<SubmissionConfig
				submission={submission}
				outputOptions={outputOptions}
				closeDialog={this.closeDialog}
				updateProperty={this.updateProperty}
			/>
		);
	}

}

let mapStateToProps = (store) => {

	let outputs: IOutputValue[] = OutputsHelper.combineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs, null);

	return {
		state: store.modalState.submissionConfig,
		components: store.processState.components,
		outputs: outputs
	};
};

export default connect<any, any, any>(mapStateToProps)(SubmissionConfigContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/submission-config.tsx